import { memo, ChangeEvent, FC } from 'react'
import { Select, Tooltip } from '@chakra-ui/react'

import { ActivityType } from 'Activities/types'

type Props = {
  isDisabled?: boolean

  activitiesTypes: ActivityType[]
  onChange: (value: string) => void
}

const FrequencieActivitiesTypesSelect: FC<Props> = ({ isDisabled, activitiesTypes, onChange }) => {
  function onSelectActivityType(event: ChangeEvent<HTMLSelectElement>) {
    const { value } = event.target
    onChange(value)
  }

  return (
    <Tooltip isDisabled={!isDisabled} label="Você selecionou todos os tipos disponíveis">
      <Select isDisabled={isDisabled} placeholder="Selecione os tipos de atividades" onChange={onSelectActivityType}>
        {activitiesTypes.map(({ id, name }) => (
          <option key={id} value={name}>
            {name}
          </option>
        ))}
      </Select>
    </Tooltip>
  )
}

export default memo(FrequencieActivitiesTypesSelect)
